import * as css from 'css/exports.module.scss';
import './CreateTask.scss';
import { Key } from 'ts-key-enum';
import { useCreateInitiativeTask } from '@hooks';
import { When } from 'react-if';
import { Button, Input, Space } from 'antd';
import { COPY_GENERIC, COPY_SPECIFIC, INITIATIVES_NEW_TASK, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import Form from 'antd/es/form';
import React, { useCallback, useEffect, useRef, useState } from 'react';
const newTaskRules = [
    {
        max: INITIATIVES_NEW_TASK.MAX_LENGTH,
        message: INITIATIVES_NEW_TASK.MAX_MESSAGE,
        type: 'string'
    }
];
export const CreateTask = ({ initiativeId }) => {
    const [addEnable, setAddEnabled] = useState(false);
    const { isProcessing, isSuccessful, request } = useCreateInitiativeTask(initiativeId);
    const formRef = useRef(null);
    const resetForm = useCallback(() => {
        var _a;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.resetFields();
    }, []);
    useEffect(() => {
        if (isSuccessful) {
            resetForm();
        }
    }, [isSuccessful, resetForm]);
    const handleCancelClick = useCallback(() => {
        resetForm();
        setAddEnabled(false);
    }, [resetForm, setAddEnabled]);
    const handleKeyDown = useCallback((e) => {
        if (e.key === Key.Escape) {
            handleCancelClick();
        }
    }, [handleCancelClick]);
    const onAdd = useCallback(() => {
        var _a;
        const name = (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.getFieldValue('newTaskName');
        const taskName = (name !== null && name !== void 0 ? name : '').trim();
        if (!taskName) {
            return;
        }
        request({ name });
    }, [request]);
    return (React.createElement(React.Fragment, null,
        React.createElement(When, { condition: !addEnable },
            React.createElement(Button, { className: 'add-task-input', id: 'initiative-add-task-button', onClick: () => setAddEnabled(true), type: 'default' }, COPY_SPECIFIC.CREATE_NEW_TASK)),
        React.createElement(When, { condition: addEnable },
            React.createElement(Form, { onFinish: onAdd, ref: formRef },
                React.createElement(Form.Item, { name: 'newTaskName', rules: newTaskRules },
                    React.createElement(Input, { allowClear: true, autoFocus: addEnable, className: 'add-task-input', disabled: isProcessing, id: 'initiative-add-task-input', onKeyDown: handleKeyDown, placeholder: PLACEHOLDERS_COPY.ADD_A_TASK, type: 'text' })),
                React.createElement(Space, { size: Number(css.size4) },
                    React.createElement(Button, { id: 'initiative-add-task-cancel-button', loading: isProcessing, onClick: handleCancelClick }, COPY_GENERIC.CANCEL),
                    React.createElement(Button, { htmlType: 'submit', id: 'initiative-add-task-confirm-button', loading: isProcessing, type: 'primary' }, COPY_SPECIFIC.SAVE_NEW_TASK))))));
};
